(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('NativeLanguage', NativeLanguage);

    NativeLanguage.$inject = ['$resource'];

    function NativeLanguage ($resource) {
        var resourceUrl =  'api/native-languages/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
